// extracted by mini-css-extract-plugin
export default {"carousel":"style_carousel__drzHt","item":"style_item__UfEHi","image":"style_image__8tkkk","controls":"style_controls__44Jt+"};